module.exports = __webpack_public_path__ + "img/Screenshot_2.0c9c27e1.png";